<template>
  <div class="mt-2">
    <div v-if="subjects.NCS && subjects.NCS.length > 0">
      <div class="my-2 sub-title underline my-3">NCS 교과</div>
      <ncs-subject v-for="(subject, index) in subjects.NCS" :key="index"
        :subject="subject" :summary="summary"/>
    </div>
    <div v-if="subjects.NONNCS && subjects.NONNCS.length > 0">
      <div class="sub-title underline my-3">비 NCS 교과</div>
      <mdb-row>
        <mdb-col md="4" class="my-3" v-for="(subject, index) in subjects.NONNCS" :key="index">
          <non-ncs-subject :subject="subject" :summary="summary"/>
        </mdb-col>
      </mdb-row>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import NcsSubject from '@/components/subject/ncs/NcsSubject.vue';
import NonNcsSubject from '@/components/subject/nonncs/NonNcsSubject';
export default {
  name: 'SubjectSummary',
  components: { NcsSubject, NonNcsSubject },
  props: ['title', 'training'],
  data: () => ({
    summary: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('subject', ['subjects']),
    ...mapGetters('auth', ['isStudent'])
  },
  async created () {
    if (this.isStudent) {
      const student = this.profile._id
      // this.summary = await testService.getTestSummary({ student });
    }
  }
}
</script>
